export default __webpack_public_path__ + "static/media/our-story-desktop.ebd12efd.gif";